import Loader from '@components/Loader'
import { AddedVariantMsg } from '@components/Product/AddedVariantPanel/AddVariantSuccessPanel'
import { Divider, Fade, useTheme } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { useContext } from 'react'
import ProductContext from '../context/ProductContext'
import { structuredData } from '../../../SEO/Product/structuredData'
import ProductInfoLinks from './ProductInfoLinks'
import ProductVariantsForm from './ProductVariantsForm'
import { useReactiveVar } from '@apollo/client'
import { isWholesaleModeVar } from '../../../../apolloClient'
import UserTranslation from '@components/UserTranslation/UserTranslation'
import ProductChips from './ProductChips'
import ProductPromoCode from './ProductPromoCode'
import ShippingDiscountCard from '@components/ShippingDiscountCard'
import ProductOverview from './ProductOverview'
import VariantProperties from './VariantProperties'
import SimilarProductsCard from './SimilarProductsCard'
import RelatedProductsCard from './RelatedProductsCard'

interface IProps {
  onGooglePushProductDetails(): void
}

const ProductDetails: React.FC<IProps> = ({ onGooglePushProductDetails }) => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const isWholesaleMode = useReactiveVar(isWholesaleModeVar)
  const { selectedVariant, reflection, lastAddedVariantInfo, setLastAddedVariantInfo, images, loading } =
    useContext(ProductContext)

  const reflectionImgUrl = images[0]?.url
  const reflectionName = reflection?.name || ''
  const isShippingRequired = reflection?.product.isShippingRequired
  const shareBtnImgUrl = `${window.location.origin}${reflectionImgUrl}`
  const tags = reflection?.product.tag.trim().split(',')

  return (
    <div>
      <div>
        <div className='relative'>
          <div className={!!lastAddedVariantInfo ? 'opacity-25 pointer-events-none' : ''}>
            <div className='hidden md:block'>
              <h1 className='font-semibold text-4xl leading-tight' itemProp='name'>
                <UserTranslation
                  entityType='product_specifics'
                  entityId={reflection?.pk}
                  fieldName='name'
                  refetchQueries={['ReflectionFullInfo']}
                >
                  {reflectionName}
                </UserTranslation>
              </h1>
              <ProductOverview text={reflection?.generatedDescription} />
            </div>

            <ProductChips />
            <ProductPromoCode />

            <div className='my-10'>
              <ShippingDiscountCard />
            </div>

            <script className='structured-data-list' type='application/ld+json'>
              {structuredData(
                reflection,
                images.map(img => img.url)
              )}
            </script>

            <SimilarProductsCard />

            {!isWholesaleMode && <ProductVariantsForm />}
            <ProductInfoLinks isDigital={!isShippingRequired} />
            {/*<div className='flex w-full justify-between items-center pb-10'>*/}
            {/*<ShareButtons*/}
            {/*  url={window.location.href}*/}
            {/*  imgUrl={shareBtnImgUrl}*/}
            {/*  title={reflectionName}*/}
            {/*  description={reflectionName}*/}
            {/*  hashtag={window.location.pathname}*/}
            {/*/>*/}
            {/*{!!reflection?.product?.feedbackCount && (*/}
            {/*  <a*/}
            {/*    className='btn btn-link p-0 text-11'*/}
            {/*    onClick={e => {*/}
            {/*      e.preventDefault()*/}
            {/*      scrollIntoView('product-feedback', {*/}
            {/*        behavior: 'smooth',*/}
            {/*        block: 'center',*/}
            {/*        inline: 'center',*/}
            {/*      })*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    {t('countReviews', {*/}
            {/*      defaultValue: '{{count}} Reviews',*/}
            {/*      count: reflection?.product?.feedbackCount || 0,*/}
            {/*    })}*/}
            {/*  </a>*/}
            {/*)}*/}
            {/*</div>*/}
          </div>
          {!smDown && (
            <Fade in={!!lastAddedVariantInfo} timeout={1000}>
              <div className='absolute top-0 left-0 right-0'>
                {!!lastAddedVariantInfo && (
                  <AddedVariantMsg
                    variant={lastAddedVariantInfo.variant}
                    imgUrl={lastAddedVariantInfo.variant.allImages[0]?.thumbnailUrl || images[0]?.url}
                    reflectionName={reflection?.name}
                    onClosePanel={() => setLastAddedVariantInfo(null)}
                    quantity={lastAddedVariantInfo.quantity}
                    supplyLinesJson={lastAddedVariantInfo.supplyLinesJson}
                    hideDuration={5000}
                  />
                )}
                <div className='bg-white opacity-75 h-20' />
              </div>
            </Fade>
          )}
          {smDown && (
            <Drawer open={!!lastAddedVariantInfo} anchor='top' onClose={() => setLastAddedVariantInfo(null)}>
              {!!lastAddedVariantInfo && (
                <div className='p-12'>
                  <AddedVariantMsg
                    variant={lastAddedVariantInfo.variant}
                    imgUrl={lastAddedVariantInfo.variant.allImages[0]?.thumbnailUrl || images[0]?.url}
                    reflectionName={reflection?.name}
                    quantity={lastAddedVariantInfo.quantity}
                    supplyLinesJson={lastAddedVariantInfo.supplyLinesJson}
                    onClosePanel={() => setLastAddedVariantInfo(null)}
                    hideDuration={5000}
                  />
                </div>
              )}
            </Drawer>
          )}
          <Loader
            className='spinner spinner--small'
            type='ThreeDots'
            color='#333'
            visible={loading}
            height={100}
            width={100}
          />
        </div>
      </div>
      <div className='my-10'>
        <Divider />
      </div>
      <div className='my-10'>
        <VariantProperties variant={selectedVariant} product={reflection?.product} weight_k={1000} length_k={1} />
      </div>
      <RelatedProductsCard />
      {/*<Divider />*/}
      {/*<div className='pt-10'>*/}
      {/*  {!!tags?.length && !!tags[0] && (*/}
      {/*    <>*/}
      {/*      <Typography className='pt-10 pb-5' variant='body2' paragraph>*/}
      {/*        <strong>{t('tags', 'Tags')}:</strong>*/}
      {/*      </Typography>*/}
      {/*      <div className='flex items-center flex-wrap'>*/}
      {/*        {tags.map((tag, i) => {*/}
      {/*          return (*/}
      {/*            <Button*/}
      {/*              component={Link}*/}
      {/*              to={getSearchUrl(tag.trim())}*/}
      {/*              variant='outlined'*/}
      {/*              color='primary'*/}
      {/*              size='small'*/}
      {/*              sx={{*/}
      {/*                marginRight: 1,*/}
      {/*                marginBottom: 1,*/}
      {/*                borderRadius: 5,*/}
      {/*              }}*/}
      {/*              key={i}*/}
      {/*            >*/}
      {/*              <strong className='text-capitalize'>{tag.trim()}</strong>*/}
      {/*            </Button>*/}
      {/*          )*/}
      {/*        })}*/}
      {/*      </div>*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</div>*/}
    </div>
  )
}

export default React.memo(ProductDetails)
